// extracted by mini-css-extract-plugin
export default {"PreferenceList":"PreferenceList_PreferenceList__oKbUp"};